import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isDateInput(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.DATE_INPUT && typeof label === 'string' && typeof value === 'string';
}
export function formatDateInput(submission) {
  if (isDateInput(submission) && submission.value) {
    return {
      label: submission.field.view.label,
      value: submission.value
    };
  }
  return undefined;
}
//# sourceMappingURL=date-input-preview.js.map